import { render, staticRenderFns } from "./checkPhone.vue?vue&type=template&id=9058fdac&scoped=true&"
import script from "./checkPhone.vue?vue&type=script&lang=js&"
export * from "./checkPhone.vue?vue&type=script&lang=js&"
import style0 from "./checkPhone.vue?vue&type=style&index=0&id=9058fdac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9058fdac",
  null
  
)

export default component.exports